import { FLOW_COLOR_TOKENS, type FlowColorToken } from '../../core/domain/flowColors'
import './FlowColorPicker.css'

interface FlowColorPickerProps {
  value: string
  onChange: (color: string) => void
  /** Compact mode for inline/popup use — no label, smaller swatches */
  compact?: boolean
  id?: string
}

/**
 * Visual swatch row for picking a flow color.
 * Each swatch is a small circle rendered with the theme CSS variable so it
 * respects light/dark mode automatically.
 */
export function FlowColorPicker({ value, onChange, compact = false, id }: FlowColorPickerProps) {
  return (
    <div className={`flow-color-picker ${compact ? 'flow-color-picker--compact' : ''}`} id={id} role="radiogroup" aria-label="Flow color">
      {FLOW_COLOR_TOKENS.map((token: FlowColorToken) => {
        const isSelected = value === token
        return (
          <button
            key={token}
            type="button"
            className={`flow-color-swatch ${isSelected ? 'flow-color-swatch--selected' : ''}`}
            style={{ '--swatch-color': `var(--flow-accent-${token})` } as React.CSSProperties}
            onClick={() => onChange(token)}
            role="radio"
            aria-checked={isSelected}
            aria-label={token}
            title={token.charAt(0).toUpperCase() + token.slice(1)}
          />
        )
      })}
    </div>
  )
}
